import { useLifeEvents } from '@/data/sources/lifeEvents';
import { useLocation } from '@/data/sources/location';
import { useVitals } from '@/data/sources/vitals';
import { currentFocus } from '../lib/segments';

export const useNowStatus = () => {
  const { data } = useLifeEvents('day');
  const { data: vitals } = useVitals();
  const { data: location } = useLocation();

  return {
    focus: currentFocus(data?.events ?? []),
    city: location?.city ?? null,
    heartRate: vitals?.heartRate ?? null,
  };
};
